import { render, staticRenderFns } from "./HorseResidence.vue?vue&type=template&id=0ecaada2&"
import script from "./HorseResidence.vue?vue&type=script&lang=js&"
export * from "./HorseResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports